module.exports = __webpack_public_path__ + "static/media/IMG_5173_cropped3.a49e0c9f.jpg";